import styled from "@emotion/styled"
import { theme } from "@pallet-hq/hegel"

export const FullPageDiv = styled.div`
    background-color: ${theme.colors.gray100};
    height: calc(100vh - 64px);
    display: flex;
    align-items: center;
    justify-content: center;
`

// TODO: Custom color usage
export const InfoDiv = styled.div`
    max-width: 330px;
    background-color: ${theme.colors.white};
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    padding: 32px;
    text-align: center;
`
